/**
 * Created by zhj on 16/9/9.
 */
function daojiaLog(bi_params,logtype){
    var log_url = "https://static.daojia.com/bi/buried_point/js/tracker.js?r=" + Math.random() + "&logv=1.1&type=" + logtype;
    if(bi_params != null){
        for(var key in bi_params){
            log_url += "&"+key+"=" + bi_params[key];
        }
        (new Image).src = log_url;
    }
}
module.exports = daojiaLog;



/** WEBPACK FOOTER **
 ** ./src/libs/daojiaLog.js
 **/